var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from "react";
import { RedButton } from "../styleComponents";
import ThemeProviderContext from "../../contexes/themeProviderContext";
var SpamButton = function SpamButton(props) {
  var themeProvider = React.useContext(ThemeProviderContext);
  var ThemedButton = themeProvider.spamButton;
  if (ThemedButton) {
    return React.createElement(ThemedButton, __assign({}, props));
  }
  return React.createElement(RedButton, {
    variant: "contained",
    disabled: props.disabled,
    onClick: props.onClick
  }, props.children);
};
export default SpamButton;